import { Telefone } from './telefone';

export class ClienteReferencia {
  public nome: string;
  public idGrauRelacionamento: number;
  public telefones?: Telefone[];

  constructor(nome?: string, idGrauRelacionamento?: number, telefones?: Telefone[]) {
    this.nome = nome;
    this.idGrauRelacionamento = idGrauRelacionamento;
    this.telefones = telefones;
  }

  setNome(nome: string) {
    this.nome = nome;
  }

  setIdGrauRelacionamento(idGrauRelacionamento: number) {
    this.idGrauRelacionamento = idGrauRelacionamento;
  }

  setTelefones(telefones: Telefone[]) {
    this.telefones = telefones;
  }
}
